import {Message} from 'element-ui';

export const successMessage = (message) => {
  Message.success(message);
};
export const errorMessage = (message) => {
  console.log(message);
  if (typeof message === 'string') {
    Message.error(message);
  } else {
    Message.error(message.message);
  }
};
